import React from 'react';
import { FMessage } from '../../hoc/IntlComponents';
import fieldProps from './fieldProps';

const ContractFieldRenderer = ({ fieldKey, value, type, getLabelId }) => {
  if (!value) return null;

  return (
    <div className="contracts-field">
      <span className="contracts-label">
        <FMessage id={getLabelId(fieldKey, type)} />
      </span>
      <span className="contracts-value">{value}</span>
    </div>
  );
};

export const ContractRenderer = ({ type, data, getLabelId }) => {
  const {
    props,
    id,
    message,
    type: contractType,
    header,
    cardClassName,
    additionalComponents,
    ...contractData
  } = data;

  const getFieldsForType = (contractType) => {
    const allFields = Object.keys(contractData).filter((key) => contractData[key]);

    if (contractType.toLowerCase() === 'self') {
      return {
        personal: ['name', 'birthday'],
        documents: ['inn'],
        passport: [
          'document_serial',
          'document_number',
          'document_date',
          'document_unit_code',
          'document_unit_name',
        ],
        banking: ['bank_name', 'bik', 'bank_account', 'corr_account'],
        addresses: ['address', 'actual_address'],
        contacts: ['email', 'phone'],
        other: ['edo_id'],
      };
    }

    if (contractType.toLowerCase() === 'ip') {
      return {
        personal: ['name'],
        documents: ['ogrnip', 'inn'],
        banking: ['bank_name', 'bik', 'bank_account', 'corr_account'],
        addresses: ['address', 'actual_address'],
        contacts: ['email', 'phone', 'contact_name'],
        other: ['edo_id', 'status'],
      };
    }

    if (contractType.toLowerCase() === 'ooo') {
      return {
        personal: ['name', 'owner'],
        documents: ['ogrn', 'inn', 'kpp'],
        banking: ['bank_name', 'bik', 'bank_account', 'corr_account'],
        addresses: ['address', 'actual_address'],
        contacts: ['email', 'phone', 'contact_name'],
        other: ['edo_id', 'status'],
      };
    }

    return { all: allFields };
  };

  const fieldsStructure = getFieldsForType(contractType);

  const renderFieldsGroup = (groupName, fields) => {
    if (!fields || fields.length === 0) return null;

    const availableFields = fields.filter((field) => contractData[field]);
    if (availableFields.length === 0) return null;

    return (
      <div className="contracts-row">
        {availableFields.map((field) => (
          <ContractFieldRenderer
            key={field}
            fieldKey={field}
            value={contractData[field]}
            type={contractType}
            getLabelId={getLabelId}
          />
        ))}
      </div>
    );
  };

  return (
    <div className="contract-content-wrapper">
      <div
        className={`contracts-${
          contractType.toLowerCase() === 'self' ? 'self-employed' : contractType.toLowerCase()
        }-content`}
      >
        {Object.entries(fieldsStructure).map(([groupName, fields]) => (
          <React.Fragment key={groupName}>
            {groupName === 'personal' && (
              <div className="contracts-row">
                <div className="contracts-field contracts-field-full">
                  <span className="contracts-label">Личные данные:</span>
                </div>
              </div>
            )}
            {groupName === 'documents' && (
              <div className="contracts-row">
                <div className="contracts-field contracts-field-full">
                  <span className="contracts-label">Документы:</span>
                </div>
              </div>
            )}
            {groupName === 'passport' && (
              <div className="contracts-row">
                <div className="contracts-field contracts-field-full">
                  <span className="contracts-label">Паспортные данные:</span>
                </div>
              </div>
            )}
            {groupName === 'banking' && (
              <div className="contracts-row">
                <div className="contracts-field contracts-field-full">
                  <span className="contracts-label">Банковские реквизиты:</span>
                </div>
              </div>
            )}
            {groupName === 'addresses' && (
              <div className="contracts-row">
                <div className="contracts-field contracts-field-full">
                  <span className="contracts-label">Адреса:</span>
                </div>
              </div>
            )}
            {groupName === 'contacts' && (
              <div className="contracts-row">
                <div className="contracts-field contracts-field-full">
                  <span className="contracts-label">Контакты:</span>
                </div>
              </div>
            )}
            {renderFieldsGroup(groupName, fields)}
          </React.Fragment>
        ))}
      </div>

      {additionalComponents && (
        <div className="contract-additional-components">{additionalComponents}</div>
      )}
    </div>
  );
};
